import type {PropsWithChildren} from 'react'
import styles from './ConnectedConversationItem.module.css'

interface ConnectedConversationItemProps {
  enabled: boolean
  type: 'commits' | 'issue' | 'review_summary'
}

export function ConnectedConversationItem({
  children,
  enabled,
  type,
}: PropsWithChildren<ConnectedConversationItemProps>) {
  if (!enabled) return <>{children}</>

  return (
    <div className={styles.ConnectedItem} data-item-type={type} data-testid="timeline-item">
      {children}
    </div>
  )
}
